import CreateAdvertiserModal from "./CreateSegmentModal";

export default CreateAdvertiserModal;
